import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbConfigSituator extends AppService {


  abstract getConfigSituator(): Observable<any>;
  abstract testeConexao(obj): Observable<any>;
  abstract salvar(obj): Observable<any>;
  abstract getContaSituator(contaId): Observable<any>;
  abstract getContasSituator(): Observable<any>;
  abstract getAllConfigAvancadas(): Observable<any>;
  abstract salvarAvancadas(objs): Observable<any>;
  abstract sincronizarPessoas(contaId): Observable<any>;
}